import { useFormContext } from 'react-hook-form';
import {
  deviceContainer,
  messageBody,
  messageBodyMessageLabelResponder,
  messageBodyMessageLabelSender,
  messageBodyMessageResponder,
  messageBodyMessageSender,
  messageHeader,
  messageHeaderCenter,
} from 'modules/templateEditor/modals/SmsSmartOptInModal/SmsSmartOptIn.styled';
import { AVATAR_COLORS, AVATAR_SIZES, Avatar } from 'ui/avatar';
import { Link } from 'ui/links';
import { FormLabel } from 'ui/formField';
import { Person } from 'ui/icons';
import { IS_VALID_URL } from 'utils/validationRegex';
import { DOUBLE_OPT_IN_PREVIEW_CONTENT } from './constants';
import { DoubleOptInPreviewContent, PreviewSection } from './ManageMessageTypeModal.styled';

export const DoubleOptInPreview = () => {
  const { watch } = useFormContext();
  const brandName = watch('brandName');
  const messagingInitiative = watch('messagingInitiative');
  const smsDisclaimerLink = watch('smsDisclaimerLink');

  const previewBrandName = brandName || '{{brandName}}';
  const previewMessagingInitiative = messagingInitiative || '{{messagingInitiative}}';
  const previewSmsDisclaimerLink = smsDisclaimerLink || '{{smsDisclaimerLink}}';

  const renderedDisclaimerLink = IS_VALID_URL.test(smsDisclaimerLink) ? (
    <Link size="caption" href={smsDisclaimerLink}>
      {smsDisclaimerLink}
    </Link>
  ) : (
    previewSmsDisclaimerLink
  );

  return (
    <PreviewSection>
      <div data-test="double-opt-in-preview">
        <FormLabel>SMS Preview</FormLabel>
        <DoubleOptInPreviewContent>
          <div style={{ ...deviceContainer }}>
            <div style={messageHeader}>
              <div style={messageHeaderCenter}>
                <Avatar
                  firstName=""
                  size={AVATAR_SIZES.LARGE}
                  color={AVATAR_COLORS.GREY}
                  data-test="preview-avatar"
                >
                  <Person width={20} height={20} />
                </Avatar>
              </div>
            </div>
            <div style={messageBody}>
              <div style={messageBodyMessageLabelResponder}>
                {DOUBLE_OPT_IN_PREVIEW_CONTENT.CONFIRMATION_SENDER_LABEL}
              </div>
              <div style={messageBodyMessageResponder}>
                {`${previewBrandName}${DOUBLE_OPT_IN_PREVIEW_CONTENT.CONFIRMATION_MESSAGE_ACTION_PROMPT}${previewMessagingInitiative}`}
              </div>
              <div style={messageBodyMessageLabelSender}>
                {DOUBLE_OPT_IN_PREVIEW_CONTENT.OPT_IN_USER_LABEL}
              </div>
              <div style={messageBodyMessageSender}>{'Y'}</div>
              <div style={messageBodyMessageLabelResponder}>
                {DOUBLE_OPT_IN_PREVIEW_CONTENT.LEGAL_DISCLAIMER_SENDER_LABEL}
              </div>
              <div style={messageBodyMessageResponder}>
                {`${previewBrandName}${DOUBLE_OPT_IN_PREVIEW_CONTENT.LEGAL_DISCLAIMER_MESSAGE}`}
                {renderedDisclaimerLink}
              </div>
            </div>
          </div>
        </DoubleOptInPreviewContent>
      </div>
    </PreviewSection>
  );
};
